module.exports = __webpack_public_path__ + "static/img/cgalss.30580cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cgalss.png
// module id = idan
// module chunks = 0